import { render, staticRenderFns } from "./TenantsFilters.vue?vue&type=template&id=2d00ec3b&"
import script from "./TenantsFilters.vue?vue&type=script&lang=js&"
export * from "./TenantsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports